module.exports = __webpack_public_path__ + "img/senalando-izqsv.272206ca.png";